<script setup>
  // TODO 既存のロジックを持ってくる
  // TODO 物件の情報は他のComponentが使用できる？
  import {
    nextTick,
    onMounted,
    ref
  } from 'vue'

  import Property from '@components/PropertySmall.vue'

  import { useAjax } from '@composables/useAjax.js'
  import { useSlick } from '@composables/useSlick.js'
  import { generateUrl } from '@shared/util.js'

  defineProps({
    title: String
  })

  const KEY_RECENTLY_VIEWED = 'recentlyViewedProperties'

  const properties = ref([])

  const storage = localStorage.getItem(KEY_RECENTLY_VIEWED) ? JSON.parse(localStorage.getItem(KEY_RECENTLY_VIEWED)) : []

  const {
    property_code: propertyCode,
    recently_viewed_path: path,
    recently_viewed_count: maxCount,
  } = window.app.page

  const { callGet } = useAjax()
  const { slickResponsive } = useSlick()

  onMounted(() => {
    const list = initializeProperties()
    pushCurrent(list)
  })

  /**
   * 最近見た物件を表示
   */
  const initializeProperties = () => {
    const list = storage.filter((code) => code != propertyCode)

    if (list.length == 0) {
      return list
    }

    Promise.allSettled(list.map((code) => callGet(generateUrl(`properties/${code}`))))
      .then((results) => {
        properties.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.property)
        nextTick(() => slickResponsive(`.listing .responsive`))
      })

    return list
  }

  /**
   * Storageに追加する
   */
  const pushCurrent = (list) => {
    if (maxCount) {
      // 物件を追加。上限を超過している場合は先頭を削除
      list.push(propertyCode)
      if (list.length > maxCount) {
        list.shift()
      }
      localStorage.setItem(KEY_RECENTLY_VIEWED, JSON.stringify(list))
    }
  }
</script>

<template>
  <div class="property_botoom_slide" id="home">
    <div v-if="properties.length > 0" class="listing">
      <h2 class="c-ttl">{{ title }}</h2>
      <div class="slider responsive">
        <template v-for="(property, index) in properties" :key="`recently-viewed-${index}`">
          <Property :property="property" />
        </template>
      </div>
    </div>
  </div>
</template>
